var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgSwirls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 73,
    viewBox: "0 0 311 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.5 27.5784C108.278 40.1905 70.9849 51.3322 56.6491 51.3269C54.2336 51.3269 52.4662 51.0107 51.4352 50.3308C45.0528 46.1092 67.9214 28.1898 123.399 -6.05742C130.066 -10.1736 136.272 -14.1528 141.996 -17.9844L142.556 -17.9844C136.763 -14.1001 130.488 -10.0735 123.723 -5.90456C68.4025 28.2425 45.5437 46.0618 51.769 50.1832C58.6522 54.7422 101.12 42.0562 150.284 27.3729C184.68 17.0955 223.671 5.45319 256.202 -1.93067C280.416 -7.42244 298.551 -9.97331 310.992 -9.62019L310.992 -9.37249C277.401 -10.3264 208.049 10.3863 150.5 27.5784Z",
    fill: "url(#paint0_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.084 69.9865C289.989 57.0265 301.978 45.5897 310.992 35.7656L310.992 36.2927C302.018 46.0271 290.146 57.3269 275.457 70.1077C245.214 96.4071 225.468 117.758 216.759 133.569C215.924 135.092 215.187 136.562 214.549 137.991L214.098 137.991C214.746 136.541 215.492 135.044 216.336 133.5C225.056 117.668 244.821 96.3017 275.084 69.9865Z",
    fill: "url(#paint1_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.344 -4.19695C65.2703 29.2755 43.0203 46.8313 49.3242 51.0476C56.3153 55.7277 98.4293 43.4951 147.191 29.3335C181.292 19.4303 219.95 8.20436 252.284 1.17889C279.129 -4.65546 298.532 -6.90594 310.992 -5.61468L310.992 -5.36699C279.1 -8.70844 206.891 12.2626 147.397 29.539C105.872 41.5977 69.1488 52.2651 54.5675 52.2651C51.9655 52.2651 50.0704 51.9277 48.9804 51.1952C42.5293 46.8787 64.7793 29.2281 119.01 -4.34978C126.649 -9.08261 133.66 -13.6257 140.023 -17.9844L140.573 -17.9844C134.141 -13.5783 127.062 -8.98249 119.334 -4.19695L119.344 -4.19695Z",
    fill: "url(#paint2_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.798 73.2574C289.685 59.2011 302.116 46.9421 310.992 36.6016L310.992 37.1603C302.135 47.4112 289.822 59.5226 274.171 73.3786C244.92 99.2669 225.949 120.343 217.79 136.033C217.446 136.697 217.122 137.356 216.808 138.004L216.356 138.004C216.67 137.335 217.004 136.661 217.367 135.97C225.547 120.264 244.537 99.1615 273.798 73.2626L273.798 73.2574Z",
    fill: "url(#paint3_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.021 -2.5524C62.1752 30.2665 40.534 47.5587 46.9065 51.8699C54.0057 56.6713 95.7956 44.8919 144.174 31.2468C178.001 21.7073 216.344 10.8977 248.482 4.23063C278.175 -1.93049 298.785 -3.75407 311 -1.28224L311 -1.024C281.278 -7.14295 205.956 14.0916 144.38 31.4523C103.533 42.9682 67.3793 53.1665 52.5623 53.1612C49.7639 53.1612 47.7313 52.7975 46.5629 52.0122C40.0332 47.5956 61.6842 30.2085 114.688 -2.71054C123.279 -8.04421 131.036 -13.1459 137.959 -18L138.509 -18C131.527 -13.0985 123.692 -7.94405 115.012 -2.55768L115.021 -2.5524Z",
    fill: "url(#paint4_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.992 37.2188L310.992 37.8143C302.401 48.5712 289.685 61.5523 273.002 76.5941C245.028 101.818 226.912 122.463 219.145 137.979L218.693 137.979C226.45 122.436 244.596 101.745 272.619 76.4728C289.557 61.1992 302.391 48.06 310.982 37.2187L310.992 37.2188Z",
    fill: "url(#paint5_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.992 37.6016L310.992 38.2445C302.862 49.5022 289.783 63.4372 271.952 79.8282C246.353 103.355 229.425 122.898 221.56 137.987L221.108 137.987C228.974 122.872 245.921 103.287 271.578 79.7122C289.695 63.0577 302.901 48.9435 310.992 37.6016Z",
    fill: "url(#paint6_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.74 -0.934381C59.1018 31.231 38.0498 48.2702 44.5009 52.6816C51.7081 57.6147 93.1838 46.2728 141.219 33.1441C174.78 23.9683 212.819 13.5698 244.79 7.25584C277.605 0.773226 299.355 -0.470579 311 3.48224L311 3.75628C284.047 -5.63561 205.288 15.8941 141.425 33.3497C101.265 44.328 65.661 54.0624 50.6084 54.0572C47.5939 54.0572 45.4043 53.6672 44.167 52.8186C37.5687 48.3019 58.6207 31.173 110.416 -1.09776C119.931 -7.02699 128.395 -12.6611 135.789 -18L136.329 -18C128.886 -12.6189 120.353 -6.92686 110.74 -0.944933L110.74 -0.934381Z",
    fill: "url(#paint7_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.522 0.62547C56.0718 32.1584 35.6089 48.9447 42.1287 53.4562C49.4439 58.5158 90.6349 47.6218 138.326 34.9992C171.632 26.187 209.387 16.1943 241.2 10.2282C277.541 3.41355 300.37 2.94447 310.984 8.79991L310.984 9.13194C310.984 9.13194 310.945 9.10558 310.916 9.08977C287.576 -4.23385 204.919 17.6331 138.513 35.21C99.0301 45.6559 63.9859 54.9319 48.6977 54.9319C45.4574 54.9319 43.1008 54.5155 41.7752 53.6037C35.1081 48.9869 55.571 32.1057 106.178 0.477913C116.587 -6.03106 125.699 -12.1922 133.475 -17.9844L134.015 -17.9844C126.19 -12.1448 117.009 -5.93093 106.512 0.630745L106.522 0.62547Z",
    fill: "url(#paint8_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.992 37.5391L310.992 38.2716C303.608 50.0247 290.205 65.0454 271.019 83.0386C247.669 104.942 231.909 123.389 224.054 137.988L223.602 137.988C231.458 123.357 247.247 104.874 270.646 82.9226C290.176 64.6027 303.716 49.3764 310.992 37.5391Z",
    fill: "url(#paint9_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.359 2.14589C53.077 33.0516 33.1934 49.5955 39.782 54.2124C47.2052 59.409 88.1212 48.9472 135.498 36.8358C168.579 28.3768 206.068 18.7899 237.724 13.1769C274.183 6.70481 297.11 6.5467 307.813 12.6867C309.03 13.3877 310.091 14.1677 310.984 15.0374L310.984 15.5381C310.022 14.5314 308.863 13.6301 307.489 12.8448C283.697 -0.800274 201.62 20.1866 135.675 37.0466C96.87 46.9708 62.3757 55.7882 46.8615 55.7882C43.366 55.7882 40.8326 55.3402 39.4285 54.3599C32.6927 49.6376 52.5762 33.0042 102.015 1.99833C113.297 -5.07457 122.999 -11.7469 131.08 -17.9766L131.61 -17.9766C123.48 -11.6995 113.72 -4.97972 102.349 2.15116L102.359 2.14589Z",
    fill: "url(#paint10_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.992 36.6641L310.992 37.5864C304.865 49.819 291.148 66.1784 270.204 86.2481C248.975 106.587 234.354 123.947 226.597 138.004L226.146 138.004C233.912 123.916 248.553 106.523 269.831 86.1375C291.256 65.6092 305.101 48.9705 310.992 36.6693L310.992 36.6641Z",
    fill: "url(#paint11_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.665 40.0393C309.775 37.5095 310.55 35.1431 310.992 32.9453L310.992 34.7794C310.531 36.4607 309.902 38.2315 309.087 40.092C303.716 52.3668 290.402 68.9634 269.516 89.4179C250.291 108.249 236.789 124.529 229.199 137.985L228.748 137.985C236.338 124.493 249.868 108.181 269.143 89.3019C290.009 68.8632 303.304 52.2878 308.675 40.034L308.665 40.0393Z",
    fill: "url(#paint12_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.223 3.61382C50.0998 33.9029 30.7857 50.2096 37.443 54.9266C44.9742 60.2655 85.635 50.2359 132.737 38.6199C165.592 30.514 202.835 21.333 234.364 16.0626C270.675 9.99103 293.622 10.0964 304.531 16.3788C307.722 18.2181 309.873 20.6109 310.992 23.5518L310.992 24.9432C310.089 21.4278 307.83 18.6187 304.217 16.5369C279.964 2.56499 198.426 22.6769 132.914 38.8308C94.7863 48.2385 60.8419 56.6079 45.0921 56.6079C41.3216 56.6079 38.5919 56.1283 37.0994 55.0689C30.2948 50.2465 49.6187 33.8449 97.899 3.46096C110.026 -4.17061 120.257 -11.3331 128.544 -17.9844L129.065 -17.9844C120.738 -11.2857 110.448 -4.07045 98.2328 3.61382L98.223 3.61382Z",
    fill: "url(#paint13_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1438 5.04209C47.1595 34.7251 28.4052 50.7946 35.1214 55.6223C42.7508 61.1088 83.1955 51.5061 130.023 40.3855C162.671 32.6327 199.679 23.8469 231.09 18.9191C267.264 13.2481 290.25 13.6171 301.365 20.0522C309.407 24.706 311.194 32.696 306.687 43.806C301.738 56.0071 289.032 72.4191 268.903 92.5996C251.573 109.971 239.161 125.176 231.807 137.994L231.355 137.994C238.71 125.144 251.15 109.902 268.52 92.4889C288.63 72.3295 301.326 55.9332 306.265 43.7533C310.742 32.7223 308.985 24.8009 301.041 20.2103C276.317 5.90115 195.29 25.1382 130.19 40.5963C92.7298 49.4928 59.3548 57.4195 43.3694 57.4195C39.2945 57.4195 36.3488 56.903 34.7581 55.7593C27.8946 50.8315 46.6588 34.6618 93.7903 4.88395C106.732 -3.29047 117.435 -10.9326 125.84 -17.9844L126.36 -17.9844C117.916 -10.8851 107.154 -3.19032 94.1241 5.03681L94.1438 5.04209Z",
    fill: "url(#paint14_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1244 6.41769C44.2595 35.4999 26.0648 51.348 32.8399 56.2811C34.4699 57.467 37.5236 57.994 41.7851 57.994C57.7705 57.994 90.6055 50.5047 127.398 42.1142C159.859 34.7093 196.651 26.3188 227.964 21.7335C264.02 16.4578 287.055 17.0955 298.387 23.6836C306.556 28.4322 308.608 36.438 304.494 47.4848C299.977 59.612 287.861 75.8555 268.488 95.7618C252.954 111.721 241.593 125.856 234.543 137.988L234.091 137.988C241.151 125.824 252.532 111.652 268.105 95.6512C287.458 75.7659 299.565 59.5435 304.072 47.4374C308.166 36.4696 306.144 28.5324 298.072 23.8417C272.857 9.18467 192.302 27.5626 127.574 42.3303C90.8019 50.7208 57.9669 58.2048 41.7654 58.2048C37.3665 58.2048 34.195 57.6514 32.4963 56.4182C25.5837 51.3796 43.7882 35.4419 89.8003 6.26483C103.518 -2.43664 114.643 -10.5478 123.067 -17.9844L123.578 -17.9844C115.124 -10.5004 103.94 -2.34175 90.1342 6.41769L90.1244 6.41769Z",
    fill: "url(#paint15_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1313 7.74581C41.3761 36.243 23.7116 51.8645 30.5554 56.9136C38.4008 62.7058 78.443 53.9516 124.809 43.8113C157.094 36.7542 193.679 28.7537 224.904 24.5163C260.852 19.6359 283.946 20.5424 295.493 27.2886C303.79 32.1321 306.108 40.1589 302.367 51.1425C298.272 63.2012 286.744 79.276 268.108 98.9188C254.263 113.513 243.953 126.578 237.247 137.988L236.785 137.988C243.501 126.546 253.841 113.444 267.715 98.8082C286.332 79.1864 297.84 63.1327 301.935 51.095C305.646 40.1853 303.368 32.2269 295.169 27.4414C269.463 12.4312 189.339 29.9501 124.966 44.0274C88.8806 51.9172 56.6054 58.9743 40.1879 58.9743C35.4355 58.9743 32.0087 58.384 30.202 57.0506C23.2304 51.9014 40.8949 36.1903 85.7975 7.59826C100.271 -1.61971 111.739 -10.1789 120.086 -17.9844L120.586 -17.9844C112.211 -10.1315 100.693 -1.51958 86.1215 7.75109L86.1313 7.74581Z",
    fill: "url(#paint16_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1934 9.03961C38.528 36.957 21.4036 52.3625 28.2966 57.5222C30.1524 58.9083 33.7363 59.5197 38.7244 59.5197C55.1713 59.5197 86.8771 52.8895 122.294 45.4898C154.413 38.7753 190.822 31.1649 221.978 27.27C257.847 22.7849 281 23.9654 292.773 30.8697C301.198 35.8133 303.77 43.8613 300.422 54.7869C296.74 66.7823 285.801 82.6885 267.901 102.073C255.657 115.333 246.348 127.345 240.035 137.996L239.583 137.996C245.907 127.313 255.235 115.27 267.518 101.973C285.399 82.6094 296.327 66.7191 300 54.75C303.328 43.8982 300.795 35.9135 292.459 31.0278C266.252 15.654 186.521 32.3191 122.461 45.7112C76.1252 55.3982 36.1028 63.7624 27.9529 57.6645C20.9323 52.4046 38.0665 36.9096 81.8694 8.8973C97.0693 -0.821356 108.813 -9.81269 116.992 -17.9766L117.483 -17.9766C109.284 -9.77052 97.4817 -0.721197 82.1934 9.05016L82.1934 9.03961Z",
    fill: "url(#paint17_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3078 10.2862C35.7225 37.6344 19.1185 52.829 26.0606 58.0994C34.1122 64.2184 73.8499 56.3022 119.842 47.1317C151.813 40.7598 188.065 33.534 219.152 29.9817C254.953 25.8919 278.185 27.3413 290.184 34.4142C298.736 39.458 301.574 47.527 298.598 58.3999C295.338 70.3321 284.979 86.0854 267.806 105.217C257.064 117.186 248.737 128.138 242.856 137.994L242.404 137.994C248.295 128.106 256.651 117.118 267.423 105.117C284.577 86.0063 294.926 70.2741 298.176 58.3682C301.132 47.5692 298.333 39.5634 289.869 34.5723C263.142 18.819 183.774 34.6408 120 47.353C85.3088 54.2678 54.1726 60.4764 37.3427 60.4764C31.7753 60.4764 27.7691 59.7965 25.7169 58.2365C18.6472 52.8659 35.261 37.5817 77.9838 10.1386C93.8612 -0.0596543 105.84 -9.48319 113.745 -17.9844L114.236 -17.9844C106.312 -9.44103 94.2834 0.0351962 78.3176 10.2862L78.3078 10.2862Z",
    fill: "url(#paint18_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4494 11.4931C32.9246 38.2826 16.841 53.2664 23.8224 58.6475C25.9335 60.2761 30.1459 60.9823 36.0275 60.977C52.8868 60.977 83.4437 55.1849 117.437 48.7444C149.281 42.7098 185.375 35.8688 216.423 32.6644C252.165 28.9698 275.495 30.6932 287.719 37.9348C296.409 43.0787 299.492 51.1741 296.9 61.9995C294.053 73.8738 284.263 89.4689 267.806 108.358C258.478 119.068 251.094 128.965 245.684 137.994L245.222 137.994C250.652 128.934 258.056 118.999 267.414 108.258C283.851 89.3899 293.621 73.8158 296.468 61.9679C299.051 51.2162 295.997 43.1841 287.405 38.0929C260.147 21.9548 181.104 36.9334 117.585 48.9658C71.5626 57.6883 31.8249 65.2197 23.4689 58.7793C16.3599 53.298 32.4533 38.2194 74.1156 11.3402C90.6411 0.678154 102.777 -9.15643 110.319 -17.9844L110.8 -17.9844C103.249 -9.11426 91.0731 0.767765 74.4593 11.4878L74.4494 11.4931Z",
    fill: "url(#paint19_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6022 12.6526C30.128 38.8887 14.555 53.667 21.5757 59.164C23.8242 60.9296 28.3999 61.6833 34.7921 61.6833C51.838 61.6833 81.7959 56.3022 115.063 50.3308C146.788 44.6335 182.755 38.1773 213.774 35.3102C249.486 32.0109 272.904 34.0084 285.374 41.4291C294.192 46.6732 297.53 54.8002 295.311 65.5729C292.876 77.3945 283.656 92.8421 267.906 111.489C259.904 120.965 253.443 129.814 248.523 137.994L248.062 137.994C252.991 129.788 259.482 120.907 267.514 111.394C283.234 92.7683 292.444 77.347 294.879 65.5518C297.089 54.8423 293.78 46.7838 285.05 41.5872C257.253 25.0486 178.484 39.1892 115.2 50.5522C81.9628 56.5183 52.0049 61.8994 34.8019 61.8994C28.2526 61.8994 23.5492 61.1194 21.2221 59.2958C14.0739 53.6986 29.6567 38.8308 70.2684 12.4997C87.4124 1.3897 99.6372 -8.84547 106.707 -17.9844L107.178 -17.9844C100.099 -8.79804 87.8248 1.48458 70.6022 12.6473L70.6022 12.6526Z",
    fill: "url(#paint20_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8141 13.7699C27.3808 39.4579 12.2987 54.0359 19.3586 59.6542C21.7642 61.5673 26.7326 62.379 33.6845 62.379C50.9072 62.379 80.2564 57.4037 112.757 51.8961C144.385 46.5361 180.234 40.4593 211.233 37.9348C246.925 35.0255 270.461 37.3076 283.177 44.9076C292.122 50.257 295.726 58.4104 293.87 69.1462C291.837 80.9151 283.187 96.2204 268.144 114.63C261.389 122.905 255.811 130.705 251.412 137.999L250.951 137.999C255.36 130.678 260.956 122.847 267.741 114.54C282.765 96.1519 291.405 80.8729 293.428 69.1252C295.274 58.4631 291.71 50.3677 282.843 45.0657C254.486 28.1213 175.973 41.4291 112.885 52.1175C80.4036 57.6251 51.0643 62.5951 33.6944 62.5951C26.5755 62.5951 21.4697 61.7571 18.9854 59.7859C11.7979 54.0728 26.8898 39.4052 66.4606 13.6223C84.1742 2.08013 96.4382 -8.53979 102.929 -17.9844L103.39 -17.9844C96.8899 -8.49762 84.5866 2.17498 66.7846 13.7699L66.8141 13.7699Z",
    fill: "url(#paint21_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2557 -17.5891C93.325 -7.90734 81.1493 3.00773 63.0626 14.8504C24.6504 40.0008 10.0691 54.3838 17.1585 60.1127C19.7311 62.1893 25.1413 63.0589 32.7118 63.0589C50.0818 63.0589 78.8025 58.4841 110.528 53.4298C142.067 48.4071 177.818 42.7098 208.817 40.5278C244.509 38.0139 268.163 40.5805 281.124 48.365C290.207 53.8198 294.056 62.0048 292.573 72.6985C290.943 84.4199 282.843 99.5829 268.507 117.771C262.91 124.865 258.187 131.617 254.338 137.999L253.876 137.999C257.735 131.585 262.488 124.807 268.104 117.676C282.43 99.5144 290.511 84.3725 292.141 72.6774C293.614 62.0522 289.804 53.9253 280.8 48.5178C251.873 31.1518 173.566 43.6269 110.646 53.6512C78.94 58.7003 50.2389 63.275 32.7315 63.275C24.9941 63.275 19.4463 62.379 16.7951 60.2392C9.58793 54.4101 24.1791 39.9428 62.7287 14.6975C81.1689 2.62297 93.266 -8.22356 99.128 -17.9844L99.4913 -17.9844C99.4128 -17.8526 99.344 -17.7209 99.2655 -17.5891L99.2557 -17.5891Z",
    fill: "url(#paint22_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.137 -15.6759C88.4616 -6.18918 76.7572 4.42545 59.3579 15.8833C21.957 40.5068 7.84711 54.6947 14.9659 60.5397C23.538 67.5809 62.8338 61.7202 108.345 54.9372C139.815 50.2465 175.478 44.9286 206.496 43.0893C242.199 40.9706 265.99 43.8219 279.216 51.796C288.436 57.3563 292.541 65.5782 291.421 76.2297C290.194 87.9089 282.653 102.935 268.995 120.896C264.478 126.842 260.58 132.539 257.29 137.994L256.829 137.994C260.128 132.518 264.046 126.784 268.582 120.812C282.211 102.872 289.752 87.8721 290.97 76.2192C292.079 65.6309 288.014 57.467 278.883 51.9541C249.376 34.1559 171.236 45.8036 108.463 55.1638C77.5624 59.7702 49.5192 63.9496 31.9038 63.9496C23.4791 63.9496 17.4305 62.9957 14.6026 60.6714C7.36591 54.7264 21.4759 40.4488 59.0142 15.7358C77.9552 3.26598 89.9148 -7.91261 95.0305 -17.9844L95.384 -17.9844C95.0011 -17.2202 94.5887 -16.4507 94.1174 -15.6759L94.137 -15.6759Z",
    fill: "url(#paint23_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0765 -13.8153C83.6368 -4.52354 72.4037 5.8012 55.6819 16.8691C19.2728 40.9707 5.64391 54.969 12.7824 60.9298C21.4526 68.1714 60.7288 62.7218 106.211 56.4078C137.622 52.0492 173.226 47.1108 204.264 45.614C240.005 43.8906 263.934 47.0265 277.426 55.2009C286.773 60.8666 291.133 69.1253 290.377 79.7452C289.542 91.3823 282.551 106.282 269.58 124.027C266.065 128.839 262.952 133.493 260.252 137.983L259.791 137.983C262.51 133.461 265.633 128.781 269.178 123.938C282.129 106.219 289.11 91.3454 289.945 79.7347C290.701 69.178 286.381 60.9773 277.102 55.3537C246.996 37.1128 168.994 47.933 106.319 56.6292C60.6699 62.9642 21.2464 68.4349 12.4092 61.051C5.15294 54.99 18.7917 40.9022 55.3284 16.7163C74.7211 3.88278 86.4941 -7.61727 90.7949 -18L91.1385 -18C90.569 -16.6244 89.8915 -15.233 89.0667 -13.8258L89.0765 -13.8153Z",
    fill: "url(#paint24_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0474 -11.9919C78.8433 -2.90041 68.062 7.13446 51.998 17.8334C16.5806 41.4185 3.41324 55.2323 10.5713 61.3091C19.3398 68.7562 58.6258 63.7177 104.108 57.8781C135.48 53.8515 171.034 49.2926 202.122 48.1383C237.912 46.8155 261.998 50.2412 275.755 58.6159C285.24 64.3923 289.855 72.688 289.452 83.2762C289.01 94.8764 282.559 109.644 270.266 127.179C267.674 130.879 265.327 134.484 263.206 137.994L262.744 137.994C264.865 134.457 267.242 130.821 269.853 127.095C282.127 109.586 288.569 94.8396 289.01 83.271C289.403 72.746 284.837 64.4977 275.421 58.774C244.697 40.0799 166.793 50.0778 104.196 58.11C58.5473 63.9654 19.1237 69.025 10.1884 61.4356C2.92228 55.2587 16.0896 41.3606 51.6445 17.6859C71.4397 4.5098 82.9476 -7.29597 86.345 -17.9844L86.6985 -17.9844C86.08 -16.0185 85.1962 -14.021 84.0376 -11.9919L84.0474 -11.9919Z",
    fill: "url(#paint25_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1228 -10.2211C74.1446 -1.32459 63.8051 8.42568 48.3892 18.7557C13.9439 41.8296 1.23798 55.4642 8.40589 61.6569C11.7738 64.5609 19.5113 65.6993 30.3122 65.6993C47.9865 65.6993 73.8499 62.653 102.099 59.3221C133.442 55.6276 168.967 51.4428 200.113 50.6365C235.972 49.7142 260.226 53.4298 274.267 62.0101C283.889 67.8918 288.75 76.2297 288.711 86.7863C288.662 98.3496 282.75 113.001 271.125 130.325C269.377 132.929 267.757 135.485 266.254 137.994L265.793 137.994C267.315 135.453 268.955 132.871 270.712 130.241C282.318 112.938 288.229 98.318 288.269 86.781C288.308 76.2824 283.487 67.9973 273.933 62.1576C242.581 42.9944 164.735 52.1702 102.188 59.5382C56.5095 64.9193 17.0663 69.5731 8.03278 61.7676C0.756842 55.48 13.4726 41.7611 48.0455 18.5976C68.1844 5.10532 79.3781 -6.99028 81.8034 -17.9844L82.1667 -17.9844C81.6071 -15.4493 80.5859 -12.8616 79.113 -10.2316L79.1228 -10.2211Z",
    fill: "url(#paint26_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2428 -8.51616C69.4904 0.180036 59.5829 9.64571 44.7856 19.6173C11.3026 42.1906 -0.951591 55.6407 6.21631 61.9494C15.1811 69.8339 54.5359 65.6123 100.096 60.7214C131.429 57.3588 166.935 53.5483 198.159 53.0951C234.107 52.568 258.547 56.5894 272.873 65.3804C282.633 71.3729 287.748 79.7529 288.063 90.2832C288.406 101.815 283.025 116.345 272.067 133.469C271.095 134.992 270.162 136.499 269.269 137.991L268.807 137.991C269.711 136.473 270.653 134.939 271.645 133.395C282.593 116.293 287.964 101.794 287.621 90.2884C287.307 79.8108 282.24 71.4836 272.539 65.5385C240.538 45.8957 162.713 54.2493 100.175 60.9585C72.9467 63.8783 47.9277 66.5663 30.2239 66.5663C18.1956 66.5663 9.52533 65.3277 5.83335 62.0811C-1.44256 55.6776 10.8215 42.1431 44.4321 19.4803C64.8754 5.69816 75.6862 -6.67152 77.0805 -17.9766L77.4438 -17.9766C77.0511 -14.8934 75.9906 -11.7311 74.233 -8.51088L74.2428 -8.51616Z",
    fill: "url(#paint27_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4157 -6.85322C64.8793 1.64797 55.3843 10.8343 41.2055 20.4581C8.66517 42.5359 -3.14712 55.8121 4.02078 62.2314C13.0838 70.3426 52.4974 66.5321 98.1561 62.1208C129.489 59.0903 165.004 55.654 196.317 55.5485C232.383 55.4273 256.999 59.7438 271.62 68.7562C281.517 74.8541 286.878 83.2762 287.546 93.7855C288.273 105.286 283.422 119.705 273.112 136.634C272.837 137.087 272.562 137.54 272.297 137.994L271.845 137.994C272.13 137.519 272.415 137.04 272.709 136.56C283 119.658 287.85 105.264 287.124 93.7907C286.456 83.3342 281.134 74.9648 271.305 68.9038C238.637 48.7708 160.792 56.297 98.2444 62.3474C52.4385 66.7746 12.8775 70.6009 3.66727 62.3474C-3.60867 55.8279 8.21351 42.4726 40.8815 20.3105C61.5801 6.26484 71.9589 -6.36837 72.2633 -17.9844L72.6266 -17.9844C72.5087 -14.3689 71.4581 -10.6532 69.4256 -6.85322L69.4157 -6.85322Z",
    fill: "url(#paint28_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6603 -5.24575C60.3301 3.05516 51.2475 11.9674 37.6677 21.2486C21.2797 32.4483 10.4984 41.2552 4.70512 48.1858C-0.68554 54.6368 -1.6184 59.3064 1.84772 62.4739C10.9991 70.8222 50.5208 67.4228 96.2777 63.4858C127.63 60.7873 163.175 57.7252 194.586 57.973C230.759 58.2523 255.592 62.8744 270.517 72.1082C280.562 78.322 286.168 86.7863 287.19 97.2745C288.26 108.332 284.264 122.03 275.328 137.994L274.867 137.994C283.812 122.024 287.818 108.332 286.748 97.285C285.736 86.8496 280.159 78.4327 270.183 72.2611C236.818 51.6274 158.933 58.3313 96.3366 63.7124C50.4226 67.6652 10.7634 71.0752 1.46478 62.5898C-5.80132 55.9596 5.58882 42.7783 37.3142 21.1064C58.2092 6.82878 68.1068 -6.05215 67.2722 -17.9844L67.6551 -17.9844C67.9203 -13.8524 66.9187 -9.59385 64.6505 -5.24575L64.6603 -5.24575Z",
    fill: "url(#paint29_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9526 -3.68049C55.8286 4.42015 47.1387 13.0636 34.1383 22.0128C18.2412 32.9542 7.80357 41.5977 2.22633 48.4387C-2.96795 54.8106 -3.80255 59.4697 -0.336424 62.6899C8.91311 71.2807 48.5428 68.2924 94.4371 64.835C125.819 62.4686 161.393 59.7912 192.932 60.3867C229.243 61.0719 254.301 66.005 269.54 75.4654C279.723 81.7847 285.585 90.3017 286.95 100.769C288.295 111.051 285.339 123.563 278.191 137.994L277.739 137.994C284.897 123.558 287.853 111.057 286.518 100.779C285.153 90.3596 279.34 81.8953 269.216 75.613C235.144 54.4628 157.161 60.3393 94.5058 65.0616C48.4544 68.5295 8.68728 71.5284 -0.709562 62.8006C-7.96584 56.0597 3.002 43.0523 33.7946 21.8653C54.8368 7.38742 64.2043 -5.73065 62.1914 -17.9844L62.5939 -17.9844C63.3206 -13.3517 62.4467 -8.56614 59.9624 -3.68573L59.9526 -3.68049Z",
    fill: "url(#paint30_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.311 -2.18364C51.3834 5.71672 43.0863 14.0967 30.6455 22.7243C15.2296 33.4128 5.12578 41.8929 -0.235433 48.6443C-5.23333 54.9425 -5.97961 59.591 -2.52331 62.8639C6.81463 71.7024 46.5917 69.1304 92.6431 66.1579C124.074 64.1288 159.697 61.8256 191.374 62.7743C227.842 63.8706 253.136 69.1146 268.699 78.8069C279.028 85.2421 285.136 93.8013 286.844 104.258C288.396 113.739 286.383 125.06 280.865 137.994L280.433 137.994C292.176 110.677 288.199 91.3136 268.365 78.9598C233.566 57.2825 155.456 62.3316 92.6922 66.3898C46.4837 69.3781 6.56918 71.9554 -2.90619 62.9798C-10.1428 56.1335 0.412641 43.3001 30.2921 22.5873C51.4325 7.93557 60.2304 -5.40389 57.0097 -17.9844L57.4221 -17.9844C58.6888 -12.8668 57.9916 -7.57004 55.311 -2.17839L55.311 -2.18364Z",
    fill: "url(#paint31_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7141 -0.718513C46.973 6.98684 39.0491 15.1033 27.1582 23.4095C12.2135 33.8502 2.45338 42.1616 -2.69182 48.8287C-7.49334 55.0478 -8.15121 59.6858 -4.70471 63.0114C4.73141 72.1082 44.6655 69.9526 90.9133 67.4597C122.403 65.7626 158.105 63.8389 189.939 65.146C226.583 66.6533 252.123 72.2136 268.02 82.1483C278.497 88.6942 284.85 97.3061 286.902 107.747C288.61 116.396 287.412 126.536 283.357 137.994L282.945 137.994C292.027 112.638 286.98 94.3546 267.696 82.3012C232.141 60.0863 153.863 64.3027 90.9722 67.6968C44.5673 70.2003 4.49575 72.3559 -5.06802 63.1274C-12.2752 56.1757 -2.1321 43.5109 26.844 23.2672C47.7095 8.68919 56.0655 -5.16672 51.7549 -17.9844L52.1968 -17.9844C54.0722 -12.3925 53.5911 -6.60554 50.7436 -0.723756L50.7141 -0.718513Z",
    fill: "url(#paint32_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1582 0.683472C42.6037 8.18855 35.043 16.052 23.6823 24.0525C9.20903 34.2455 -0.227098 42.3989 -5.1661 48.9763C-9.78106 55.1217 -10.3603 59.7491 -6.9237 63.1221C2.6008 72.4824 42.7313 70.7484 89.1951 68.7457C120.763 67.3806 156.544 65.8364 188.544 67.5071C225.385 69.4256 251.18 75.3074 267.421 85.4845C278.035 92.1411 284.643 100.8 287.049 111.236C288.846 119.02 288.335 127.985 285.566 137.994L285.154 137.994C291.752 114.567 285.782 97.3536 267.097 85.6427C230.766 62.8745 152.292 66.2633 89.2344 68.9828C42.6233 70.9909 2.35531 72.7301 -7.29681 63.2381C-14.4745 56.1863 -4.73403 43.6901 23.3485 23.9102C44.214 9.21102 51.9514 -4.8663 46.384 -17.9844L46.8357 -17.9844C49.3887 -11.9339 49.1726 -5.66211 46.168 0.683472L46.1582 0.683472Z",
    fill: "url(#paint33_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6688 2.0276C38.2911 9.33767 31.0838 16.9481 20.2338 24.6482C6.23181 34.5988 -2.89011 42.5887 -7.62291 49.0819C-12.0513 55.1534 -12.5422 59.7703 -9.12521 63.1908C0.487668 72.8199 40.8243 71.5128 87.5434 70.0002C119.2 68.9725 155.089 67.813 187.276 69.8474C224.323 72.1874 250.402 78.3907 266.997 88.8156C277.768 95.5828 284.622 104.3 287.361 114.72C289.178 121.608 289.227 129.393 287.538 137.983L287.145 137.983C291.456 116.427 284.681 100.295 266.663 88.9684C229.537 65.6363 150.817 68.1872 87.5729 70.2321C40.7163 71.75 0.242154 73.0571 -9.50814 63.2962C-16.6466 56.1443 -7.29884 43.8168 19.9 24.5007C40.7262 9.71188 47.8156 -4.58678 40.9913 -18L41.443 -18C44.7324 -11.5016 44.8208 -4.77126 41.6885 2.01704L41.6688 2.0276Z",
    fill: "url(#paint34_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.717 -16.6773C40.0947 -10.1525 40.2715 -3.41694 37.2276 3.3292C34.0265 10.439 27.1532 17.8071 16.8137 25.2173C-9.03987 43.7428 -18.2501 56.181 -11.3376 63.2381C-1.63633 73.1412 38.9459 72.2663 85.9301 71.2491C149.489 69.8735 228.601 68.1659 266.689 92.1569C277.608 99.0348 284.717 107.805 287.8 118.219C289.567 124.175 290.039 130.789 289.243 137.988L288.88 137.988C291.119 118.256 283.666 103.209 266.365 92.3097C228.414 68.4084 149.42 70.116 85.9497 71.4863C38.8182 72.5035 -1.89164 73.3836 -11.7205 63.3487C-18.8197 56.1019 -9.86467 43.9431 16.4701 25.0802C36.5206 10.7131 43.1975 -3.31151 36.3046 -16.6141C36.0689 -17.0726 35.8136 -17.5311 35.5387 -17.9844L36.0002 -17.9844C36.2555 -17.5469 36.501 -17.1147 36.7268 -16.6773L36.717 -16.6773Z",
    fill: "url(#paint35_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2673 -15.0013C35.537 -8.5767 35.7333 -1.98868 32.8465 4.58353C29.8124 11.4983 23.273 18.624 13.4146 25.7548C-11.6044 43.8429 -20.4219 56.1072 -13.5486 63.2591C-3.75898 73.4469 37.0884 73.0042 84.377 72.4929C148.191 71.7972 227.608 70.9381 266.54 95.5089C277.616 102.497 284.971 111.325 288.388 121.734C290.027 126.726 290.793 132.159 290.685 137.999L290.312 137.999C290.705 120.048 282.722 106.081 266.206 95.6564C227.401 71.1648 148.103 72.0291 84.377 72.7196C36.9411 73.2361 -4.02405 73.6788 -13.9413 63.3593C-17.378 59.7807 -17.0539 55.1322 -12.93 49.145C-8.56047 42.7994 -0.0571109 35.0993 13.0611 25.6125C32.1887 11.7829 38.5023 -1.86219 31.845 -14.9486C31.3246 -15.9658 30.7257 -16.9777 30.058 -17.9844L30.5194 -17.9844C31.1675 -16.9988 31.7567 -16.008 32.2574 -15.0066L32.2673 -15.0013Z",
    fill: "url(#paint36_linear_73596_107421)",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8391 -13.3886C31.0009 -7.0746 31.2168 -0.628879 28.4871 5.77468C25.62 12.4997 19.3946 19.3882 9.99783 26.245C-14.1865 43.8956 -22.6211 55.9965 -15.8067 63.2275C-6.18399 73.4363 33.0922 73.6946 79.1436 73.6946C81.618 73.6946 84.1023 73.6946 86.6159 73.6946C150.027 73.6946 227.451 74.169 266.491 98.8451C277.724 105.944 285.334 114.825 289.095 125.239C290.538 129.224 291.412 133.482 291.766 137.999L291.422 137.999C290.194 121.771 281.819 108.89 266.167 98.9979C226.479 73.9107 146.826 73.9318 82.8356 73.9318C35.0757 73.9476 -6.18399 73.9476 -16.1896 63.3382C-19.5968 59.7174 -19.3415 55.0847 -15.3943 49.1713C-11.2212 42.9101 -3.02223 35.3628 9.65417 26.108C27.8882 12.8002 33.868 -0.465492 27.4267 -13.3253C26.6412 -14.8906 25.6789 -16.4454 24.5497 -17.9844L25.021 -17.9844C26.1306 -16.4612 27.0732 -14.9328 27.8489 -13.3833L27.8391 -13.3886Z",
    fill: "url(#paint37_linear_73596_107421)",
    fillOpacity: 0.31
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_73596_107421",
    x1: 124.957,
    y1: 18.4446,
    x2: 259.71,
    y2: 64.0953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_73596_107421",
    x1: 241.821,
    y1: 89.4936,
    x2: 297.27,
    y2: 94.2294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_73596_107421",
    x1: 123.174,
    y1: 18.9377,
    x2: 259.328,
    y2: 64.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_73596_107421",
    x1: 243.433,
    y1: 89.8974,
    x2: 297.602,
    y2: 94.4527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_73596_107421",
    x1: 121.417,
    y1: 19.4013,
    x2: 258.949,
    y2: 65.6478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_73596_107421",
    x1: 245.101,
    y1: 90.1767,
    x2: 297.946,
    y2: 94.5385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_73596_107421",
    x1: 246.826,
    y1: 90.3628,
    x2: 298.303,
    y2: 94.5159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_73596_107421",
    x1: 119.673,
    y1: 19.8722,
    x2: 258.565,
    y2: 66.4189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_73596_107421",
    x1: 117.928,
    y1: 20.3393,
    x2: 258.156,
    y2: 67.2003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_73596_107421",
    x1: 248.606,
    y1: 90.3335,
    x2: 298.673,
    y2: 94.2584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_73596_107421",
    x1: 116.217,
    y1: 20.7931,
    x2: 257.766,
    y2: 67.9654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_73596_107421",
    x1: 250.422,
    y1: 89.9267,
    x2: 299.054,
    y2: 93.5956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_73596_107421",
    x1: 252.279,
    y1: 88.1525,
    x2: 299.453,
    y2: 91.4808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_73596_107421",
    x1: 114.521,
    y1: 21.2202,
    x2: 257.377,
    y2: 68.7124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_73596_107421",
    x1: 112.275,
    y1: 63.9954,
    x2: 267.281,
    y2: 88.6842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_73596_107421",
    x1: 109.896,
    y1: 63.9927,
    x2: 264.77,
    y2: 88.6394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_73596_107421",
    x1: 107.519,
    y1: 63.9927,
    x2: 262.336,
    y2: 88.6209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_73596_107421",
    x1: 105.231,
    y1: 64.0005,
    x2: 260.071,
    y2: 88.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_73596_107421",
    x1: 102.996,
    y1: 63.9954,
    x2: 257.936,
    y2: 88.6627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_73596_107421",
    x1: 100.797,
    y1: 63.9954,
    x2: 255.921,
    y2: 88.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_73596_107421",
    x1: 98.6371,
    y1: 63.9954,
    x2: 254.021,
    y2: 88.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_73596_107421",
    x1: 96.5355,
    y1: 63.9982,
    x2: 252.27,
    y2: 88.9251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_73596_107421",
    x1: 94.5199,
    y1: 63.9982,
    x2: 250.669,
    y2: 89.0616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_73596_107421",
    x1: 92.5506,
    y1: 63.9954,
    x2: 249.214,
    y2: 89.2294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_73596_107421",
    x1: 90.623,
    y1: 63.9826,
    x2: 247.875,
    y2: 89.4106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_73596_107421",
    x1: 88.7221,
    y1: 63.9954,
    x2: 246.658,
    y2: 89.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_73596_107421",
    x1: 86.93,
    y1: 63.9954,
    x2: 245.631,
    y2: 89.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_73596_107421",
    x1: 85.1463,
    y1: 63.9977,
    x2: 244.705,
    y2: 90.2008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_73596_107421",
    x1: 83.4349,
    y1: 63.9954,
    x2: 243.925,
    y2: 90.5121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_73596_107421",
    x1: 81.7579,
    y1: 63.9954,
    x2: 243.304,
    y2: 90.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_73596_107421",
    x1: 80.1473,
    y1: 63.9954,
    x2: 242.82,
    y2: 91.2592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_73596_107421",
    x1: 78.575,
    y1: 63.9954,
    x2: 242.478,
    y2: 91.6854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_73596_107421",
    x1: 77.0921,
    y1: 63.9954,
    x2: 242.32,
    y2: 92.1481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_73596_107421",
    x1: 75.6011,
    y1: 63.9954,
    x2: 242.261,
    y2: 92.6533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_73596_107421",
    x1: 74.1882,
    y1: 63.9826,
    x2: 242.383,
    y2: 93.1861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_73596_107421",
    x1: 72.827,
    y1: 63.9927,
    x2: 242.652,
    y2: 93.7853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_73596_107421",
    x1: 71.5419,
    y1: 63.9982,
    x2: 243.107,
    y2: 94.4221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_73596_107421",
    x1: 70.227,
    y1: 63.9982,
    x2: 243.544,
    y2: 95.0672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSwirls);
export default __webpack_public_path__ + "static/media/bg-swirls.561c510926b1e9ab583f9892588e226d.svg";
export { ForwardRef as ReactComponent };